<template lang='pug'>
#app
	Nav
	router-view
</template>

<script>
import Nav from '@/components/Nav.vue';
export default {
	name: 'Sapuboltinn',
	components: { Nav }

};
</script>

<style lang="less">
.debug  {
	border: 1px solid red;
}
* {
	// border: 1px solid red;
	max-width: 100vw;
}
html {
	overflow-x: hidden;
}
body {
	margin: 0px;
	background-color: #F7F7F2;
	overflow-x: hidden;
	width: 100vw !important;
	font-family: 'Modelica';
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Black.otf") format("opentype");
  font-weight: 900;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-BlackItalic.otf") format("opentype");
  font-weight: 900;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Bold.otf") format("opentype");
  font-weight: 700;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-BoldItalic.otf") format("opentype");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-ExtraBold.otf") format("opentype");
  font-weight: 800;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-ExtraBoldItalic.otf") format("opentype");
  font-weight: 800;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Hairline.otf") format("opentype");
  font-weight: 100;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-HairlineItalic.otf") format("opentype");
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Light.otf") format("opentype");
  font-weight: 300;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-LightItalic.otf") format("opentype");
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Medium.otf") format("opentype");
  font-weight: 500;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-MediumItalic.otf") format("opentype");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Regular.otf") format("opentype");
  font-weight: 400;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-RegularItalic.otf") format("opentype");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-Thin.otf") format("opentype");
  font-weight: 200;
}
@font-face {
  font-family: "Modelica";
  src: url("/fonts/BwModelicaSS01-ThinItalic.otf") format("opentype");
  font-weight: 200;
  font-style: italic;
}
</style>
